/**
 * ACCOUNT-SEARCH-PARENT.MODAL
 * Define parent account for account (from consulting)
 */

import ListButton from "@/components/list-button"
import ListCell from "@/components/list-cell"
import ListIcon from "@/components/list-icon"
import ListItem from "@/components/list-item"
import Modal from "@/components/modal"
import Space from "@/components/space"
import { store } from "@/core/root-reducer"
import { STATUS_LOADED, STATUS_LOADING } from "@/redux/_status.types"
import { accountFetchParents_AsSupervisor } from "@/redux/account.actions"
import { Account } from "@/redux/account.types"
import { faPlus, faShieldAlt } from "@fortawesome/free-solid-svg-icons"
import { useEffect, useState } from "react"
import { getImageUrl } from "@/utils/get-image-url"

interface OwnProps {
  onClick: Function
  onClose: Function
}

function AccountSearchParentModal(props: OwnProps) {
  const [accounts, setAccounts] = useState<Account[]>([])
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    load()
    async function load() {
      const response: any = await store.dispatch(accountFetchParents_AsSupervisor())
      setIsLoading(false)
      setAccounts(response.error ? [] : response.map((x) => new Account(x)))
    }
  }, [])

  function handleClick(accountId) {
    props.onClick(accountId)
    props.onClose()
  }

  return (
    <Modal
      status={isLoading ? STATUS_LOADING : STATUS_LOADED}
      title="Recherche compte parent"
      isCloseButtonVisible
      onClose={() => props.onClose()}>
      <div className="modal-content-list">
        {accounts.map((account) => (
          <ListItem key={account.id}>
            <ListIcon
              fallbackIcon={faShieldAlt}
              iconColor={account.colors.brandPrimary}
              image={
                account.options.image
                  ? getImageUrl("Accounts", account.id)
                  : null
              }
            />

            <ListCell width={200} text={account.name} />
            <Space />
            <ListButton onClick={() => handleClick(account.id)} icon={faPlus} />
          </ListItem>
        ))}
      </div>
    </Modal>
  )
}

export default AccountSearchParentModal
